import script from "./LoadingIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&setup=true&lang=js"

import "./LoadingIcon.vue?vue&type=style&index=0&id=57ed61ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ed61ad"]])

export default __exports__